import { render } from "./Select2Input.vue?vue&type=template&id=8aec9ba0&scoped=true"
import script from "./Select2Input.vue?vue&type=script&lang=js"
export * from "./Select2Input.vue?vue&type=script&lang=js"

import "./Select2Input.vue?vue&type=style&index=0&id=8aec9ba0&lang=scss"
import "./Select2Input.vue?vue&type=style&index=1&id=8aec9ba0&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aec9ba0"]])

export default __exports__